import React from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow } from '@mui/material';
import FinancialProductRulesEditDetailsIncomesTableRow from './FinancialProductRulesEditDetailsIncomesTableRow';
import { useTranslation } from 'react-i18next';
import { isValid } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';
import { sequence, get } from '@totalsoft/change-tracking-react';

const FinancialProductRulesEditDetailsIncomesTableBody = ({
  canWrite,
  incomeList,
  onCloseEdit,
  onDelete,
  onSave,
  financialProductRuleIncomeCurrencyList,
  financialProductRuleIncomeTypeList,
  financialProductRuleIncomeValidation
}) => {
  const [t] = useTranslation();

  return (
    <TableBody>
      {!isValid(financialProductRuleIncomeValidation) &&
        !sequence(incomeList)?.find((_, index) => {
          return !isValid(financialProductRuleIncomeValidation[index]);
        }) && (
          <TableRow>
            <Typography color='error'>{t('FinancialProduct.Details.Rules.Details.Incomes.ValidationList')}</Typography>
          </TableRow>
        )}
       {sequence(incomeList)?.map((incomeLens, index) => {
        return (
          <FinancialProductRulesEditDetailsIncomesTableRow
            canWrite={canWrite}
            key={`${index}_${incomeLens.financialProductRuleIncomeId |> get}`}
            incomeLens={incomeLens}
            index={index}
            onCloseEdit={onCloseEdit}
            onDelete={onDelete}
            onSave={onSave}
            financialProductRuleIncomeCurrencyList={financialProductRuleIncomeCurrencyList}
            financialProductRuleIncomeTypeList={financialProductRuleIncomeTypeList}
            financialProductRuleIncomeValidation={financialProductRuleIncomeValidation[index]}
            listValid={isValid(financialProductRuleIncomeValidation)}
          />
        );
      })}
    </TableBody>
  );
};

FinancialProductRulesEditDetailsIncomesTableBody.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  incomeList: PropTypes.object.isRequired,
  onCloseEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  financialProductRuleIncomeCurrencyList: PropTypes.array.isRequired,
  financialProductRuleIncomeTypeList: PropTypes.array.isRequired,
  financialProductRuleIncomeValidation: PropTypes.object.isRequired
};

export default FinancialProductRulesEditDetailsIncomesTableBody;
